import { takeLatest, put } from 'redux-saga/effects';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { GET_USER_EMAIL_ID_REQUEST, PUT_USER_EMAIL } from '../actionTypes/NativeAppActionTypes';
import { DP_USER_EMAIL } from '../helpers/myAlerts/getMyALertsEmailId';

export function* saveUserEmail(action) {
    const userEmail = action.payload && action.payload.userEmail;
    if (userEmail) {
        TokenProvider.set(DP_USER_EMAIL, userEmail);
        yield put({
            type: PUT_USER_EMAIL,
            payload: action.payload,
        });
    }
}

const nativeAppsUserDetailsSaga = function* nativeAppsUserDetailsSaga() {
    yield takeLatest(GET_USER_EMAIL_ID_REQUEST, saveUserEmail);
};
nativeAppsUserDetailsSaga.sagaName = 'nativeAppsUserDetailsSaga';

export default nativeAppsUserDetailsSaga;
